// layout/UserLayout.tsx
import React from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import { LocalStorageManager } from "../lib/localStorage-manager";
import { tokenManager } from "../lib/token-manager";

const UserLayout: React.FC = () => {
  const navigate = useNavigate();
  const username = LocalStorageManager.getUserName();
  const tsmclogo = require("../assets/images/TSMC_LOGO.jpg");

  const signOut = () => {
    tokenManager.removeToken();
    LocalStorageManager.removeOrgPrimaryId();
    LocalStorageManager.removeUserName();
    LocalStorageManager.removeOrgdata();
    navigate("/");
  };

  return (
    <div className="app-shell">
      <Sidebar />
      <main className="app-main layout-main">
        <div className="app-heading">
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <img src={tsmclogo} alt="TSMC Logo" className="app-heading-logo" />
            <span className="app-heading-title">
              Continuing Professional Development - Telangana Medical Council
            </span>
          </div>

          <div className="profile-chip global-chip">
            <span className="email-text">
              <i className="bi bi-envelope-fill"></i>
              {username}
            </span>
            <button type="button" className="ghost" onClick={signOut}>
              Logout
            </button>
          </div>
        </div>

        <div className="layout-content">
          <Outlet />
        </div>

        <Footer />
      </main>
    </div>
  );
};

export default UserLayout;
